import { Category } from '@olxpwa-lib/categories';

export const getCategoryPath = (
    categories: Record<string, Category>,
    currentCategory: Category
): Array<Category> => {
    if (!currentCategory) {
        return [];
    }
    if (!currentCategory.parentId || !categories[currentCategory.parentId]) {
        return [currentCategory];
    }

    return [
        ...getCategoryPath(
            categories,
            categories[currentCategory.parentId] ?? ({} as Category)
        ),
        currentCategory
    ];
};
